module.exports = __webpack_public_path__ + "img/index-s-1.bd287ebb.png";